import { Button } from "components/atoms";
import { COMPLETE, IN_PROGRESS, NOT_STARTED } from "utils/constants";

interface IProps {
  contentObjectType: any;
  status: string;
  isLocked?: boolean;
  handlePrimaryBtnClick?: () => any;
  handleSecondaryBtnClick?: () => any;
  drillSmartResult?: any; // DrillSmartResult object with Status, MoveNext, CompletedCount, etc.
}

export const ButtonsByContentObjectTypes = ({
  contentObjectType,
  status,
  isLocked = false,
  handlePrimaryBtnClick,
  handleSecondaryBtnClick,
  drillSmartResult,
}: IProps) => {
  switch (contentObjectType) {
    case "Exam":
    case "SubjectExam":
    case "AAMC":
      if (isLocked === true) {
        return (
          <Button
            type="score"
            icon={false}
            label="Unlock All Content"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (NOT_STARTED.includes(status)) {
        return (
          <Button
            type="score"
            icon={false}
            label="Start Online Test"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (IN_PROGRESS.includes(status)) {
        return (
          <Button
            type="score"
            icon={false}
            label="Resume"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (COMPLETE.includes(status)) {
        return (
          <>
            <Button
              type="online"
              icon={false}
              label="View Score Report"
              styles="tab-layout-home-page-custom-style-btn"
              onClick={handleSecondaryBtnClick}
            />
            <Button
              type="score"
              icon={false}
              label="Restart Test"
              styles="tab-layout-home-page-custom-style-btn"
              onClick={handlePrimaryBtnClick}
            />
          </>
        );
      } else {
        return null;
      }

    case "MiniDiagnostic":
    case "PairedDrill":
      if (isLocked === true) {
        return (
          <Button
            type="score"
            icon={false}
            label="Unlock All Content"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (NOT_STARTED.includes(status)) {
        return (
          <Button
            type="score"
            icon={false}
            label="Start Diagnostic Exam"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (IN_PROGRESS.includes(status)) {
        return (
          <Button
            type="score"
            icon={false}
            label="Resume"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (COMPLETE.includes(status)) {
        return (
          <>
            <Button
              type="online"
              icon={false}
              label="View Results"
              styles="tab-layout-home-page-custom-style-btn"
              onClick={handleSecondaryBtnClick}
            />
            <Button
              type="score"
              icon={false}
              label="Restart Diagnostic Exam"
              styles="tab-layout-home-page-custom-style-btn"
              onClick={handlePrimaryBtnClick}
            />
          </>
        );
      } else {
        return null;
      }

    case "OfflineReading":
    case "OfflineDrill":
      if (isLocked === true) {
        return (
          <Button
            type="score"
            icon={false}
            label="Unlock All Content"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (NOT_STARTED.includes(status)) {
        return (
          <Button
            type="score"
            icon={false}
            label="Update Status"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (IN_PROGRESS.includes(status)) {
        return (
          <Button
            type="score"
            icon={false}
            label="Update Status"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (COMPLETE.includes(status)) {
        return null;
      } else {
        return null;
      }

    case "Video":
    case "Articulate":
      if (isLocked === true) {
        return (
          <Button
            type="score"
            icon={false}
            label="Unlock All Content"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (NOT_STARTED.includes(status)) {
        return (
          <Button
            type="score"
            icon={false}
            label="Start Lesson"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (IN_PROGRESS.includes(status)) {
        return (
          <Button
            type="score"
            icon={false}
            label="Resume"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (COMPLETE.includes(status)) {
        return (
          <Button
            type="score"
            icon={false}
            label="Restart Lesson"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else {
        return null;
      }

    case "Drill":
    case "DrillUnique":
    case "DrillAdaptive":
      if (isLocked === true) {
        return (
          <Button
            type="score"
            icon={false}
            label="Unlock All Content"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (NOT_STARTED.includes(status)) {
        return (
          <Button
            type="score"
            icon={false}
            label="Start Drill"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (IN_PROGRESS.includes(status)) {
        return (
          <Button
            type="score"
            icon={false}
            label="Resume"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (COMPLETE.includes(status)) {
        return (
          <>
            <Button
              type="online"
              icon={false}
              label="View Score Report"
              styles="tab-layout-home-page-custom-style-btn"
              onClick={handleSecondaryBtnClick}
            />
            <Button
              type="score"
              icon={false}
              label="Retake Drill"
              styles="tab-layout-home-page-custom-style-btn"
              onClick={handlePrimaryBtnClick}
            />
          </>
        );
      } else {
        return null;
      }

    case "DrillSmart":
      // Check if content is locked first
      if (isLocked === true) {
        return (
          <Button
            type="score"
            icon={false}
            label="Unlock All Content"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      }
      
      // DrillSmart button text is determined by DrillSmartResult status
      if (!drillSmartResult) {
        return (
          <Button
            type="score"
            icon={false}
            label="Start DrillSmart"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      }

      const drillSmartStatus = drillSmartResult.Status || "NotStarted";
      const moveNext = drillSmartResult.MoveNext || false;
      const completedCount = drillSmartResult.CompletedCount || 0;

      // Determine button text based on DrillSmartResult status
      if (drillSmartStatus === "NotStarted" || drillSmartStatus === "Not Started") {
        return (
          <Button
            type="score"
            icon={false}
            label="Start DrillSmart"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else if (drillSmartStatus === "InProgress" || drillSmartStatus === "In Progress") {
        if (moveNext) {
          return (
            <Button
              type="score"
              icon={false}
              label="Continue DrillSmart"
              styles="tab-layout-home-page-custom-style-btn"
              onClick={handlePrimaryBtnClick}
            />
          );
        } else {
          return (
            <Button
              type="score"
              icon={false}
              label="Resume"
              styles="tab-layout-home-page-custom-style-btn"
              onClick={handlePrimaryBtnClick}
            />
          );
        }
      } else if (drillSmartStatus === "Completed" || drillSmartStatus === "Complete") {
        return (
          <Button
            type="score"
            icon={false}
            label="View"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      } else {
        // Default fallback
        return (
          <Button
            type="score"
            icon={false}
            label="Start DrillSmart"
            styles="tab-layout-home-page-custom-style-btn"
            onClick={handlePrimaryBtnClick}
          />
        );
      }

    default:
      return null;
  }
};
